
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/arcade-machines/craft",
      function () {
        return require("private-next-pages/arcade-machines/craft/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/arcade-machines/craft"])
      });
    }
  